import * as React from 'react';
import { ICheckboxProps } from './ICheckbox';

const Checkbox = (props: ICheckboxProps) => {
    return (
        <div className='d-flex align-items-center'>
            <input type='checkbox' id={props.name} checked={props.checked} defaultChecked={props.defaultChecked} disabled={props.disabled} onChange={props.onChange} className='me-2' />
            <label htmlFor={props.name}>{props.title}</label>
        </div>
    );
};
export default Checkbox;
